import { render, staticRenderFns } from "./zoneBanner.vue?vue&type=template&id=ddc2179a&scoped=true&"
import script from "./zoneBanner.vue?vue&type=script&lang=ts&"
export * from "./zoneBanner.vue?vue&type=script&lang=ts&"
import style0 from "./zoneBanner.vue?vue&type=style&index=0&id=ddc2179a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc2179a",
  null
  
)

export default component.exports